import { VStack } from '@pets-ui/VStack/VStack'
import { type OrderModel } from '../model/order-model'
import { OrderBrands } from './order-brands'
import OrderDelivery from './order-delivery'
import { OrderTotal } from './order-total'

interface Props {
  order: OrderModel
}

export const OrderInfo = (props: Props) => {
  const totalInfo = props.order.getTotalInfo()

  return (
    <VStack gap={4}>
      <OrderDelivery deliveryInfo={props.order.getCustomDeliveryInfo()} />
      <OrderBrands order={props.order} />
      <OrderTotal
        total={totalInfo.total}
        shippingFee={totalInfo.shippingFee}
        itemAmount={totalInfo.itemAmount ?? 0}
        tax={totalInfo.tax}
        discountAmount={props.order.order.discount_total ?? null}
      />
    </VStack>
  )
}
